import { currencyFormat } from "../utils/currencyFormat";

function TransactionCard (props) {
    return(        
        <div className="mt-7 rounded-xl bg-gray-50 p-5">
            <div>
                <div className="flex justify-between items-start">
                    <div className=" mb-2">
                        <h4 className="text-xl font-semibold mb-0">{props.header}</h4>
                        {props.type === "bayar" && (
                            <span className="text-sm text-green-600 font-bold">
                                <svg className="inline-block" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-login-2 inline-block"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2" /><path d="M3 12h13l-3 -3" /><path d="M13 15l3 -3" /></svg>
                                &nbsp; BAYAR</span>
                        )}
                        {props.type === "ambil" && (
                            <span className="text-sm text-red-600 font-bold">
                                <svg className="inline-block" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-logout-2 inline-block"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M10 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2" /><path d="M15 12h-12l3 -3" /><path d="M6 15l-3 -3" /></svg>
                                &nbsp; AMBIL / KURANGI</span>
                        )}
                        <span className="text-xs text-gray-500">{` - ID${generateRandomString(5)}i${props.id}`}</span>
                    </div>
                    <span className="text-sm">{props.date}</span>
                </div>
                {props.jumlahSembako != 0 && (
                    <div className="mt-3">
                        <div className="border-t-1 border-gray-200 mt-3 mb-2"></div>
                        Sembako {currencyFormat(props.jumlahSembako)}
                        <span className="inline-block bg-[#8BE8E5] ml-5 mr-2 rounded-lg pl-2 pt-1 pb-1 pr-2 text-sm">{`${props.jmlSaham} Saham`}</span>
                        <span className="inline-block bg-[#D5FFE4] rounded-lg pl-2 pt-1 pb-1 pr-2  text-sm">{`${props.nomerSembako} Nomer`}</span>
                    </div>
                )}
                {props.jumlahTabungan != 0 && (
                    <div className="mt-3">
                        <div className="border-t-1 border-gray-200 mt-3 mb-2"></div>
                        Tabungan {currencyFormat(props.jumlahTabungan)}
                </div>
                )}
            </div>
        </div> 
    )
}

function generateRandomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
}

export default TransactionCard;